import { Empty } from "antd";
import classNames from "classnames";
import styles from "./index.module.less";

/**
 * @param {{title?: string, subtitle?: string | React.ReactNode, size?: "small" | "normal"} & import("antd").EmptyProps}
 * @returns
 */
export default function HBEmpty({ title, subtitle, size, ...props }) {
  return (
    <Empty
      imageStyle={{
        height: 166,
      }}
      description={
        <div
          className={classNames([
            styles.description,
            size === "small" ? styles.small : null,
          ])}
        >
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
      }
      image={
        "//cdn.dancf.com/fe-assets/img/6a5695b2efbda504b26a212d160553ec.svg"
      }
      {...props}
    />
  );
}
